/**
 * @generated SignedSource<<b1886c6a3bb93172b03f1ed4130cccd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsMainTopicContent$data = {
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null> | null;
  readonly " $fragmentType": "helpersCheckIsMainTopicContent";
};
export type helpersCheckIsMainTopicContent$key = {
  readonly " $data"?: helpersCheckIsMainTopicContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsMainTopicContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsMainTopicContent"
};

(node as any).hash = "a4b1f8649aa0caef4fee0a1c473e2f19";

export default node;
